import React from 'react'
import Skeleton from '../Skeleton'

const AppSkeleton = () => {
    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900 overflow-x-hidden">
            {/* Desktop Top Navigation Skeleton */}
            <nav className="hidden lg:block bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 sticky top-0 z-40">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center justify-between h-16">
                        {/* Logo */}
                        <div className="flex items-center space-x-2">
                            <Skeleton className="h-8 w-8 rounded-lg" />
                            <Skeleton className="h-6 w-24" />
                        </div>

                        {/* Desktop Navigation */}
                        <div className="flex items-baseline space-x-4">
                            {[1, 2, 3, 4, 5, 6].map((i) => (
                                <Skeleton key={i} className="h-9 w-24 rounded-xl" />
                            ))}
                        </div>

                        {/* Right side - User menu and theme toggle */}
                        <div className="flex items-center space-x-4">
                            <Skeleton className="h-9 w-9 rounded-xl" />
                            <div className="flex items-center space-x-3">
                                <Skeleton className="h-8 w-8 rounded-full" />
                                <div className="hidden xl:block space-y-1">
                                    <Skeleton className="h-3 w-24" />
                                    <Skeleton className="h-3 w-32" />
                                </div>
                                <Skeleton className="h-8 w-8 rounded-full" />
                            </div>
                        </div>
                    </div>
                </div>
            </nav>

            {/* Mobile Header Skeleton */}
            <header className="lg:hidden fixed top-0 left-0 right-0 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 z-30">
                <div className="flex items-center justify-between px-4 py-2">
                    <div className="flex items-center space-x-2">
                        <Skeleton className="h-8 w-8 rounded-lg" />
                        <Skeleton className="h-5 w-20" />
                    </div>

                    <div className="flex items-center space-x-3">
                        <Skeleton className="h-8 w-8 rounded-xl" />
                        <Skeleton className="h-8 w-8 rounded-xl" />
                    </div>
                </div>
            </header>

            {/* Main Content Skeleton */}
            <main
                className="flex-1 lg:pb-0 pt-14 lg:pt-0"
                style={{
                    paddingBottom: 'calc(56px + 8px)' // Approximate mobile nav height
                }}
            >
                <div className="p-6 max-w-7xl mx-auto">
                    {/* Header */}
                    <div className="mb-6 lg:mb-8">
                        <Skeleton className="h-8 w-48 mb-2" />
                        <Skeleton className="h-4 w-64" />
                    </div>

                    {/* Stats Grid */}
                    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 lg:gap-6 mb-6">
                        {[1, 2, 3, 4].map((i) => (
                            <div key={i} className="card p-4 lg:p-6 h-24 lg:h-32">
                                <Skeleton className="h-4 w-20 mb-2" />
                                <Skeleton className="h-8 w-32" />
                            </div>
                        ))}
                    </div>

                    {/* Content Block */}
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                        <div className="card p-6 h-64">
                            <Skeleton className="h-full w-full rounded-lg" />
                        </div>
                        <div className="card p-6 h-64">
                            <Skeleton className="h-full w-full rounded-lg" />
                        </div>
                    </div>
                </div>
            </main>

            {/* Mobile Bottom Navigation Skeleton */}
            <nav
                className="lg:hidden fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 z-30"
                style={{
                    paddingBottom: '8px'
                }}
            >
                <div className="grid grid-cols-3 h-14">
                    {[1, 2, 3].map((i) => (
                        <div key={i} className="flex flex-col items-center justify-center space-y-1">
                            <Skeleton className="h-5 w-5 rounded-full" />
                            <Skeleton className="h-2 w-10" />
                        </div>
                    ))}
                </div>
            </nav>
        </div>
    )
}

export default AppSkeleton
